import {
  GridColumnVisibilityModel,
  GridFilterModel,
  GridSortModel,
} from '@mui/x-data-grid';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

export interface GridStateOptions {
  columns?: GridColumnVisibilityModel;
  filter?: GridFilterModel;
  sort?: GridSortModel;
}

export interface GridState {
  [key: string]: GridStateOptions;
}

export function defaultAdministrationStates(): GridState {
  return {
    [NESTED_ROUTES.ADMINISTRATION.ACCOUNTS]: {
      sort: [{ field: 'number', sort: 'asc' }],
    },
    [NESTED_ROUTES.ADMINISTRATION.BILLS]: {
      sort: [{ field: 'startDate', sort: 'desc' }],
    },
    [NESTED_ROUTES.ADMINISTRATION.BUDGETS]: {
      sort: [{ field: 'name', sort: 'asc' }],
    },
    [NESTED_ROUTES.ADMINISTRATION.ENERGY_ASSETS]: {
      sort: [{ field: 'name', sort: 'asc' }],
    },
    [NESTED_ROUTES.ADMINISTRATION.FACILITIES]: {
      sort: [{ field: 'name', sort: 'asc' }],
    },
    [NESTED_ROUTES.ADMINISTRATION.FACILITY_GROUPS]: {
      sort: [{ field: 'name', sort: 'asc' }],
    },
    [NESTED_ROUTES.ADMINISTRATION.METERS]: {
      sort: [{ field: 'createdAt', sort: 'desc' }],
    },
    [NESTED_ROUTES.ADMINISTRATION.PROJECTS]: {
      sort: [{ field: 'name', sort: 'asc' }],
    },
    [NESTED_ROUTES.ADMINISTRATION.UTILITIES]: {
      sort: [{ field: 'name', sort: 'asc' }],
    },
    [NESTED_ROUTES.ADMINISTRATION.WORK_ORDERS]: {
      sort: [{ field: 'title', sort: 'asc' }],
    },
  };
}

export function defaultSysAdminStates(): GridState {
  return {
    [NESTED_ROUTES.SYSTEM_ADMINISTRATION.ORGANIZATIONS]: {
      sort: [{ field: 'name', sort: 'asc' }],
    },
    [NESTED_ROUTES.SYSTEM_ADMINISTRATION.ORGANIZATION_GROUPS]: {
      sort: [{ field: 'name', sort: 'asc' }],
    },
    [NESTED_ROUTES.SYSTEM_ADMINISTRATION.USERS]: {
      sort: [{ field: 'name', sort: 'asc' }],
    },
  };
}

export function defaultBillAutomationStates(): GridState {
  return {
    [NESTED_ROUTES.BILL_AUTOMATION.CREDENTIALS]: {},
    [NESTED_ROUTES.BILL_AUTOMATION.BILL_UPLOAD]: {
      sort: [{ field: 'uploadTimestamp', sort: 'desc' }],
    },
    [NESTED_ROUTES.BILL_AUTOMATION.SPREADSHEET_UPLOAD]: {
      sort: [{ field: 'uploadTimestamp', sort: 'desc' }],
    },
  };
}

export function defaultAlertsStates(): GridState {
  return {
    [BASE.ALERTS]: {
      sort: [{ field: 'createdAt', sort: 'desc' }],
    },
  };
}

export function defaultDataInsightsStates(): GridState {
  return {
    [NESTED_ROUTES.SUMMARY.DATA_INSIGHTS]: {
      sort: [{ field: 'date', sort: 'desc' }],
    },
  };
}

export function defaultGlobalTableStates(): GridState {
  return {
    ...defaultAdministrationStates(),
    ...defaultSysAdminStates(),
    ...defaultBillAutomationStates(),
    ...defaultAlertsStates(),
    ...defaultDataInsightsStates(),
  };
}
